import {defineStore} from 'pinia';

import {ModuleBudgetItemDetail} from '../moduleConst';

import {BaseDictionaryStore} from '../baseDictionaryStore';

import budgetItemDetailAPI from '@/apis/di/budgetItemDetailAPI';

const budgetItemDetailStore = new BaseDictionaryStore(budgetItemDetailAPI);

export const useBudgetItemDetailStore = defineStore(ModuleBudgetItemDetail, {
  state: () => ({
    ...budgetItemDetailStore.state,
    _config: {
      key: 'budget_item_detail_id',
      code: 'budget_item_detail_code',
      name: 'budget_item_detail_name',
      table: 'di_budget_item_detail',
      moduleName: 'Tiết',
      quickFollow: 'active',
      defaultSort: 'budget_item_detail_code',
    },
    moduleName: 'budgetItemDetail',
  }),
  actions: {
    ...budgetItemDetailStore.action,
  },
  getters: {
    ...budgetItemDetailStore.getters,
  },
});
